import { defineNuxtPlugin } from '#app/nuxt'
import { LazyFrontendAccountCustomerGroupRegistrationPage, LazyFrontendBlogPost, LazyFrontendDetailPage, LazyFrontendLandingPage, LazyFrontendNavigationPage, LazyFrontendShopStudioRecipesRecipeDetailPage, LazyLanguageSwitcher, LazyLoadingOverlay, LazyAccountAddressCard, LazyAccountAddressForm, LazyAccountChangePassword, LazyAccountLoginForm, LazyAccountLoginFormPlain, LazyAccountMenu, LazyAccountOrder, LazyAccountOrderDetails, LazyAccountOrderDownloads, LazyAccountOrderLineItem, LazyAccountOrderSummary, LazyAccountPersonalData, LazyAccountPersonalEmail, LazyAccountRecoverPassword, LazyAccountRegisterForm, LazyAccountResetPasswordForm, LazyAccountOrderLineItemCredit, LazyAccountOrderLineItemCustom, LazyAccountOrderLineItemProduct, LazyAccountOrderLineItemPromotion, LazyCheckoutCartItem, LazyCheckoutPromotionCode, LazyCheckoutSideCart, LazyCheckoutCartProductItem, LazyCheckoutCartPromotionItem, LazyCmsBlockCrossSelling, LazyCmsBlockGalleryBuybox, LazyCmsBlockImageTextBubble, LazyCmsBlockNetzpBlog6Block, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockShopStudioRecipesRecipeListing, LazyCmsBlockSidebarFilter, LazyCmsBlockText, LazyCmsBlockTextTwoColumn, LazyCmsElementAdvantagesHeadlineIcons, LazyCmsElementBuyBox, LazyCmsElementCategoryBoxes, LazyCmsElementCrossSelling, LazyCmsElementFaqTabs, LazyCmsElementForm, LazyCmsElementFormContact, LazyCmsElementFormRepairreg, LazyCmsElementFormReturn, LazyCmsElementFormWarranty, LazyCmsElementHeadlineImageWithSubAndText, LazyCmsElementHeadlineTextBackground, LazyCmsElementHeadlineTextButtonBackground, LazyCmsElementHeadlineTwoRowImageText, LazyCmsElementHeroImageHeadlineTextButton, LazyCmsElementHistorySlider, LazyCmsElementImage, LazyCmsElementImageBanner, LazyCmsElementImageGallery, LazyCmsElementImageLeftHeadlineTextButton, LazyCmsElementImageRightHeadlineTextButton, LazyCmsElementImageTextSlider, LazyCmsElementInspireSlider, LazyCmsElementMoorlFbForm, LazyCmsElementNetzpBlog6, LazyCmsElementNewsletterBanner, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductListing, LazyCmsElementProductSlider, LazyCmsElementRepresantationSlider, LazyCmsElementReviewSlider, LazyCmsElementSeoTextWithFourRows, LazyCmsElementShopStudioRecipesRecipeListing, LazyCmsElementSidebarFilter, LazyCmsElementTabNavigation, LazyCmsElementText, LazyCmsElementWhoWeAre, LazyCmsElementItemsHistorySliderItem, LazyCmsElementItemsInspireSliderItem, LazyCmsElementItemsReviewSlideItem, LazyCmsElementItemsImageTextSliderItem, LazyCmsHelpersBuildUrlPrefix, LazyCmsHelpersDeepMerge, LazyCmsHelpersGetTranslations, LazyCmsHelpersGetUrlPrefix, LazyCmsSectionDefault, LazyCmsSectionSidebar, LazyCmsSkeletonProductCardSkeleton, LazyCommonBlogBox, LazyCommonBlogDetail, LazyCommonBlogListSlider, LazyCommonRecipeDetail, LazyCommonRecipeImageText, LazyCommonRecipePrint, LazyCommonRecipeProductSlider, LazyCommonSwSlider, LazyErrorsMaintainMode, LazyErrorsRoutingNotFound, LazyFormsContactForm, LazyFormsCustomContactForm, LazyFormsRepairRequestForm, LazyFormsReturnForm, LazyFormsSwContactForm, LazyFormsSwNewsletterForm, LazyFormsWarrantyForm, LazyLayoutHeaderRight, LazyLayoutHeaderTop, LazyLayoutBreadcrumbs, LazyLayoutCheckoutFooter, LazyLayoutCheckoutHeader, LazyLayoutCustomFooter, LazyLayoutFooter, LazyLayoutHeader, LazyLayoutNotification, LazyLayoutNotifications, LazyLayoutSideMenu, LazyLayoutSidebar, LazyLayoutStoreSearch, LazyLayoutTopNavigation, LazyLayoutTopNavigationMobile, LazyListingFiltersListingFilter, LazyListingFilters, LazyListingFiltersPrice, LazyListingFiltersProperties, LazyListingFiltersRating, LazyListingFiltersShippingFree, LazyListingFiltersSwCategoryFilter, LazyListingFiltersSwFilterPrice, LazyListingFiltersSwFilterProperties, LazyListingFiltersSwFilterRating, LazyListingFiltersSwFilterShippingFree, LazyListingFiltersSwProductListingFilter, LazyListingFiltersSwProductListingFilters, LazyProductBundleProductLineItem, LazyProductCard, LazyProductReviews, LazyProductReviewsForm, LazyProductSliderCard, LazyProductSuggestSearch, LazyProductUnits, LazyProductSwListingProductPrice, LazyProductSwProductAddToCart, LazyProductSwProductCard, LazyProductDetailAddBundleToCart, LazyProductDetailMobGalleryImg, LazyProductDetailProductAddToCart, LazyProductDetailProductBasicInfo, LazyProductDetailProductFaq, LazyProductDetailProductImageGallery, LazyProductDetailProductImagePopup, LazyProductDetailProductVariantConfigurator, LazySharedAccountAddressForm, LazySharedButton, LazySharedCountryStateInput, LazySharedFancybox, LazySharedListingProductPrice, LazySharedModal, LazySharedPagination, LazySharedPrice, LazySharedRangeSlider, LazySharedWishlist, LazyUtilitiesGtmTrackings, LazyUtilities, LazyCmsGenericBlock, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsPage, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageCover, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeColumn, LazyCmsBlockImageThreeCover, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductHeading, LazyCmsBlockProductThreeColumn, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockTextThreeColumn, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsElementCategoryNavigation, LazyCmsElementCustomForm, LazyCmsElementImageGallery3dPlaceholder, LazyCmsElementImageSlider, LazyCmsElementManufacturerLogo, LazyCmsElementProductBox, LazyCmsElementProductName, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyProductCardSkeleton, LazyUnoIcon } from '#components'
const lazyGlobalComponents = [
  ["FrontendAccountCustomerGroupRegistrationPage", LazyFrontendAccountCustomerGroupRegistrationPage],
["FrontendBlogPost", LazyFrontendBlogPost],
["FrontendDetailPage", LazyFrontendDetailPage],
["FrontendLandingPage", LazyFrontendLandingPage],
["FrontendNavigationPage", LazyFrontendNavigationPage],
["FrontendShopStudioRecipesRecipeDetailPage", LazyFrontendShopStudioRecipesRecipeDetailPage],
["LanguageSwitcher", LazyLanguageSwitcher],
["LoadingOverlay", LazyLoadingOverlay],
["AccountAddressCard", LazyAccountAddressCard],
["AccountAddressForm", LazyAccountAddressForm],
["AccountChangePassword", LazyAccountChangePassword],
["AccountLoginForm", LazyAccountLoginForm],
["AccountLoginFormPlain", LazyAccountLoginFormPlain],
["AccountMenu", LazyAccountMenu],
["AccountOrder", LazyAccountOrder],
["AccountOrderDetails", LazyAccountOrderDetails],
["AccountOrderDownloads", LazyAccountOrderDownloads],
["AccountOrderLineItem", LazyAccountOrderLineItem],
["AccountOrderSummary", LazyAccountOrderSummary],
["AccountPersonalData", LazyAccountPersonalData],
["AccountPersonalEmail", LazyAccountPersonalEmail],
["AccountRecoverPassword", LazyAccountRecoverPassword],
["AccountRegisterForm", LazyAccountRegisterForm],
["AccountResetPasswordForm", LazyAccountResetPasswordForm],
["AccountOrderLineItemCredit", LazyAccountOrderLineItemCredit],
["AccountOrderLineItemCustom", LazyAccountOrderLineItemCustom],
["AccountOrderLineItemProduct", LazyAccountOrderLineItemProduct],
["AccountOrderLineItemPromotion", LazyAccountOrderLineItemPromotion],
["CheckoutCartItem", LazyCheckoutCartItem],
["CheckoutPromotionCode", LazyCheckoutPromotionCode],
["CheckoutSideCart", LazyCheckoutSideCart],
["CheckoutCartProductItem", LazyCheckoutCartProductItem],
["CheckoutCartPromotionItem", LazyCheckoutCartPromotionItem],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockNetzpBlog6Block", LazyCmsBlockNetzpBlog6Block],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockShopStudioRecipesRecipeListing", LazyCmsBlockShopStudioRecipesRecipeListing],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsElementAdvantagesHeadlineIcons", LazyCmsElementAdvantagesHeadlineIcons],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCategoryBoxes", LazyCmsElementCategoryBoxes],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementFaqTabs", LazyCmsElementFaqTabs],
["CmsElementForm", LazyCmsElementForm],
["CmsElementFormContact", LazyCmsElementFormContact],
["CmsElementFormRepairreg", LazyCmsElementFormRepairreg],
["CmsElementFormReturn", LazyCmsElementFormReturn],
["CmsElementFormWarranty", LazyCmsElementFormWarranty],
["CmsElementHeadlineImageWithSubAndText", LazyCmsElementHeadlineImageWithSubAndText],
["CmsElementHeadlineTextBackground", LazyCmsElementHeadlineTextBackground],
["CmsElementHeadlineTextButtonBackground", LazyCmsElementHeadlineTextButtonBackground],
["CmsElementHeadlineTwoRowImageText", LazyCmsElementHeadlineTwoRowImageText],
["CmsElementHeroImageHeadlineTextButton", LazyCmsElementHeroImageHeadlineTextButton],
["CmsElementHistorySlider", LazyCmsElementHistorySlider],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageBanner", LazyCmsElementImageBanner],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementImageLeftHeadlineTextButton", LazyCmsElementImageLeftHeadlineTextButton],
["CmsElementImageRightHeadlineTextButton", LazyCmsElementImageRightHeadlineTextButton],
["CmsElementImageTextSlider", LazyCmsElementImageTextSlider],
["CmsElementInspireSlider", LazyCmsElementInspireSlider],
["CmsElementMoorlFbForm", LazyCmsElementMoorlFbForm],
["CmsElementNetzpBlog6", LazyCmsElementNetzpBlog6],
["CmsElementNewsletterBanner", LazyCmsElementNewsletterBanner],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementRepresantationSlider", LazyCmsElementRepresantationSlider],
["CmsElementReviewSlider", LazyCmsElementReviewSlider],
["CmsElementSeoTextWithFourRows", LazyCmsElementSeoTextWithFourRows],
["CmsElementShopStudioRecipesRecipeListing", LazyCmsElementShopStudioRecipesRecipeListing],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsElementTabNavigation", LazyCmsElementTabNavigation],
["CmsElementText", LazyCmsElementText],
["CmsElementWhoWeAre", LazyCmsElementWhoWeAre],
["CmsElementItemsHistorySliderItem", LazyCmsElementItemsHistorySliderItem],
["CmsElementItemsInspireSliderItem", LazyCmsElementItemsInspireSliderItem],
["CmsElementItemsReviewSlideItem", LazyCmsElementItemsReviewSlideItem],
["CmsElementItemsImageTextSliderItem", LazyCmsElementItemsImageTextSliderItem],
["CmsHelpersBuildUrlPrefix", LazyCmsHelpersBuildUrlPrefix],
["CmsHelpersDeepMerge", LazyCmsHelpersDeepMerge],
["CmsHelpersGetTranslations", LazyCmsHelpersGetTranslations],
["CmsHelpersGetUrlPrefix", LazyCmsHelpersGetUrlPrefix],
["CmsSectionDefault", LazyCmsSectionDefault],
["CmsSectionSidebar", LazyCmsSectionSidebar],
["CmsSkeletonProductCardSkeleton", LazyCmsSkeletonProductCardSkeleton],
["CommonBlogBox", LazyCommonBlogBox],
["CommonBlogDetail", LazyCommonBlogDetail],
["CommonBlogListSlider", LazyCommonBlogListSlider],
["CommonRecipeDetail", LazyCommonRecipeDetail],
["CommonRecipeImageText", LazyCommonRecipeImageText],
["CommonRecipePrint", LazyCommonRecipePrint],
["CommonRecipeProductSlider", LazyCommonRecipeProductSlider],
["CommonSwSlider", LazyCommonSwSlider],
["ErrorsMaintainMode", LazyErrorsMaintainMode],
["ErrorsRoutingNotFound", LazyErrorsRoutingNotFound],
["FormsContactForm", LazyFormsContactForm],
["FormsCustomContactForm", LazyFormsCustomContactForm],
["FormsRepairRequestForm", LazyFormsRepairRequestForm],
["FormsReturnForm", LazyFormsReturnForm],
["FormsSwContactForm", LazyFormsSwContactForm],
["FormsSwNewsletterForm", LazyFormsSwNewsletterForm],
["FormsWarrantyForm", LazyFormsWarrantyForm],
["LayoutHeaderRight", LazyLayoutHeaderRight],
["LayoutHeaderTop", LazyLayoutHeaderTop],
["LayoutBreadcrumbs", LazyLayoutBreadcrumbs],
["LayoutCheckoutFooter", LazyLayoutCheckoutFooter],
["LayoutCheckoutHeader", LazyLayoutCheckoutHeader],
["LayoutCustomFooter", LazyLayoutCustomFooter],
["LayoutFooter", LazyLayoutFooter],
["LayoutHeader", LazyLayoutHeader],
["LayoutNotification", LazyLayoutNotification],
["LayoutNotifications", LazyLayoutNotifications],
["LayoutSideMenu", LazyLayoutSideMenu],
["LayoutSidebar", LazyLayoutSidebar],
["LayoutStoreSearch", LazyLayoutStoreSearch],
["LayoutTopNavigation", LazyLayoutTopNavigation],
["LayoutTopNavigationMobile", LazyLayoutTopNavigationMobile],
["ListingFiltersListingFilter", LazyListingFiltersListingFilter],
["ListingFilters", LazyListingFilters],
["ListingFiltersPrice", LazyListingFiltersPrice],
["ListingFiltersProperties", LazyListingFiltersProperties],
["ListingFiltersRating", LazyListingFiltersRating],
["ListingFiltersShippingFree", LazyListingFiltersShippingFree],
["ListingFiltersSwCategoryFilter", LazyListingFiltersSwCategoryFilter],
["ListingFiltersSwFilterPrice", LazyListingFiltersSwFilterPrice],
["ListingFiltersSwFilterProperties", LazyListingFiltersSwFilterProperties],
["ListingFiltersSwFilterRating", LazyListingFiltersSwFilterRating],
["ListingFiltersSwFilterShippingFree", LazyListingFiltersSwFilterShippingFree],
["ListingFiltersSwProductListingFilter", LazyListingFiltersSwProductListingFilter],
["ListingFiltersSwProductListingFilters", LazyListingFiltersSwProductListingFilters],
["ProductBundleProductLineItem", LazyProductBundleProductLineItem],
["ProductCard", LazyProductCard],
["ProductReviews", LazyProductReviews],
["ProductReviewsForm", LazyProductReviewsForm],
["ProductSliderCard", LazyProductSliderCard],
["ProductSuggestSearch", LazyProductSuggestSearch],
["ProductUnits", LazyProductUnits],
["ProductSwListingProductPrice", LazyProductSwListingProductPrice],
["ProductSwProductAddToCart", LazyProductSwProductAddToCart],
["ProductSwProductCard", LazyProductSwProductCard],
["ProductDetailAddBundleToCart", LazyProductDetailAddBundleToCart],
["ProductDetailMobGalleryImg", LazyProductDetailMobGalleryImg],
["ProductDetailProductAddToCart", LazyProductDetailProductAddToCart],
["ProductDetailProductBasicInfo", LazyProductDetailProductBasicInfo],
["ProductDetailProductFaq", LazyProductDetailProductFaq],
["ProductDetailProductImageGallery", LazyProductDetailProductImageGallery],
["ProductDetailProductImagePopup", LazyProductDetailProductImagePopup],
["ProductDetailProductVariantConfigurator", LazyProductDetailProductVariantConfigurator],
["SharedAccountAddressForm", LazySharedAccountAddressForm],
["SharedButton", LazySharedButton],
["SharedCountryStateInput", LazySharedCountryStateInput],
["SharedFancybox", LazySharedFancybox],
["SharedListingProductPrice", LazySharedListingProductPrice],
["SharedModal", LazySharedModal],
["SharedPagination", LazySharedPagination],
["SharedPrice", LazySharedPrice],
["SharedRangeSlider", LazySharedRangeSlider],
["SharedWishlist", LazySharedWishlist],
["UtilitiesGtmTrackings", LazyUtilitiesGtmTrackings],
["Utilities", LazyUtilities],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsPage", LazyCmsPage],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementImageGallery3dPlaceholder", LazyCmsElementImageGallery3dPlaceholder],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["ProductCardSkeleton", LazyProductCardSkeleton],
["UnoIcon", LazyUnoIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
